import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useRef } from 'react';
import { useLogTicks } from 'react-d3-utils';
import HorizontalAxis from './HorizontalAxis';
import VerticalAxis from './VerticalAxis';
function LogAxis(props) {
    const { position, tickLabelFormat, scale, ...otherProps } = props;
    const axisRef = useRef(null);
    const direction = position === 'left' || position === 'right' ? 'vertical' : 'horizontal';
    const primaryTicks = useLogTicks(scale, direction, axisRef, {
        tickFormat: tickLabelFormat,
    });
    const AxisComponent = direction === 'vertical' ? VerticalAxis : HorizontalAxis;
    return (_jsx(AxisComponent, { scale: scale, axisRef: axisRef, primaryTicks: primaryTicks, position: position, ...otherProps }));
}
export default memo(LogAxis);
//# sourceMappingURL=LogAxis.js.map